import React, { Component } from 'react';

class PrintCommitmentBracketRemoval extends Component {

    render() {
        const { customer, data } = this.props;

        const now = new Date();

        const month = String(now.getMonth() + 1).padStart(2, '0'); // 01–12
        const year = now.getFullYear(); // 2026

        return (
            <div className="print-page">

                {/* Quốc hiệu */}
                <div className="header">
                    <div className="header-left">
                        Công ty TNHH Anh Nguyễn Beauty
                        <br />
                        Cơ sở KB, CB: Nha khoa CHINGO
                    </div>

                    <div className="header-center">
                        <div className="fw-bold uppercase">
                            CỘNG HÒA XÃ HỘI CHỦ NGHĨA VIỆT NAM
                        </div>
                        <div className="national-sub">
                            Độc lập - Tự do - Hạnh phúc
                        </div>
                    </div>

                    <div className="header-right"></div>
                </div>

                {/* Tiêu đề */}
                <div className="text-center fw-bold uppercase mt-24" style={{ fontSize: 18 }}>
                    GIẤY CAM KẾT KHI THÁO MẮC CÀI CHỈNH NHA
                </div>

                <div className="text-center mt-8" style={{ fontStyle: 'italic' }}>
                    (Áp dụng cho khách hàng yêu cầu tháo mắc cài trước khi kết thúc phác đồ điều trị)
                </div>

                <div className="mt-16">
                    Hôm nay, ngày …… / …… /…… , tại ..........................................................
                </div>

                {/* I. Thông tin khách hàng */}
                <div className="mt-24 fw-bold">I. THÔNG TIN KHÁCH HÀNG</div>

                <ul>
                    <li>Họ và tên: .................................................................</li>
                    <li>Ngày sinh: .................................................................</li>
                    <li>
                        Số CCCD/Hộ chiếu: ..........................
                        &nbsp;&nbsp;Ngày cấp: ..........
                        &nbsp;&nbsp;Nơi cấp: ..........
                    </li>
                    <li>Số điện thoại: .................................................................</li>
                    <li>Địa chỉ: .................................................................</li>
                </ul>

                {/* II. Thông tin điều trị */}
                <div className="mt-24 fw-bold">II. THÔNG TIN ĐIỀU TRỊ</div>

                <ul>
                    <li>Dịch vụ: Chỉnh nha (niềng răng mắc cài)</li>
                    <li>Ngày bắt đầu điều trị: .................................................................</li>
                    <li>Bác sĩ điều trị: .................................................................</li>
                    <li>
                        Tình trạng điều trị hiện tại:
                        <ul>
                            <li>☐ Chưa hoàn tất phác đồ</li>
                            <li>☐ Đang trong quá trình chỉnh nha</li>
                        </ul>
                    </li>
                </ul>

                {/* III. Nội dung cam kết */}
                <div className="mt-24 fw-bold">III. NỘI DUNG CAM KẾT</div>

                <div className="mt-16">
                    Tôi xác nhận rằng:
                </div>

                <ol>
                    <li>
                        Việc <b>tháo mắc cài tại thời điểm hiện tại là theo yêu cầu cá nhân của tôi</b>,
                        không phải do chỉ định chuyên môn từ phía bác sĩ hoặc phòng khám.
                    </li>

                    <li>
                        Tôi đã được bác sĩ/nhân viên y tế của phòng khám
                        <b> giải thích rõ ràng, đầy đủ</b> về các rủi ro và hậu quả có thể xảy ra khi
                        tháo mắc cài trước khi hoàn tất phác đồ điều trị, bao gồm nhưng không giới hạn:
                        <ul>
                            <li>Răng có thể <b>chạy lại, sai lệch khớp cắn</b> so với kế hoạch ban đầu</li>
                            <li>Kết quả thẩm mỹ và chức năng <b>không đạt như mong muốn</b></li>
                            <li>Có thể cần niềng răng lại từ đầu nếu muốn tiếp tục điều trị trong tương lai</li>
                            <li>Phát sinh thêm chi phí điều trị sau này (nếu có)</li>
                        </ul>
                    </li>

                    <li>
                        Tôi <b>tự nguyện yêu cầu tháo mắc cài</b>, đã hiểu rõ và <b>tự chịu hoàn toàn trách nhiệm</b> đối với mọi hậu quả phát sinh
                        sau khi tháo mắc cài.
                    </li>

                    <li>
                        Sau khi ký giấy cam kết này, tôi <b>cam kết không khiếu nại,
                            không khiếu kiện, không yêu cầu bồi thường</b> đối với phòng khám,
                        bác sĩ và các nhân sự liên quan về kết quả điều trị chỉnh nha
                        sau khi tháo mắc cài.
                    </li>

                    <li>
                        Tôi đồng ý rằng phòng khám <b>không còn nghĩa vụ bảo hành,
                            theo dõi hay chịu trách nhiệm</b> về kết quả chỉnh nha
                        kể từ thời điểm tháo mắc cài
                        <span style={{ fontStyle: 'italic' }}>
                            &nbsp;(trừ các dịch vụ khác nếu có thỏa thuận riêng)
                        </span>.
                    </li>
                </ol>

                {/* IV. Xác nhận */}
                <div className="mt-24 fw-bold">IV. XÁC NHẬN</div>

                <div className="mt-16">
                    Tôi đã đọc kỹ, hiểu rõ toàn bộ nội dung trên và hoàn toàn đồng ý ký tên xác nhận.
                </div>

                {/* Chữ ký */}
                <div className="mt-48" style={{ display: 'flex', justifyContent: 'space-between' }}>
                    <div className="text-center" style={{ width: '45%' }}>
                        <div className="fw-bold">Khách hàng</div>
                        <div>(Ký, ghi rõ họ tên)</div>
                        <div className="mt-100">Ngày …… /  …… / …… </div>
                    </div>

                    <div className="text-center" style={{ width: '45%' }}>
                        <div className="fw-bold">Đại diện phòng khám</div>
                        <div>(Ký, ghi rõ họ tên, đóng dấu)</div>
                        <div className="mt-100">Ngày …… /  …… / …… </div>
                    </div>
                </div>

                <style>
                    {`
                        @page {
                            size: A4;
                            margin: 1cm 1.2cm 1cm 1.8cm;
                            /* top, right, bottom, left */
                        }

                        @media print {
                            body {
                                font-family: "Times New Roman", serif;
                                font-size: 14pt;
                                line-height: 1.5;
                                color: #000;
                            }

                            .print-page {
                                width: 100%;
                            }

                            .text-center {
                                text-align: center;
                            }

                            .text-right {
                                text-align: right;
                            }

                            .fw-bold {
                                font-weight: bold;
                            }

                            .uppercase {
                                text-transform: uppercase;
                            }

                            .mt-10 { margin-top: 10px; }
                            .mt-16 { margin-top: 16px; }
                            .mt-24 { margin-top: 24px; }
                            .mt-32 { margin-top: 32px; }
                            .mt-48 { margin-top: 48px; }
                            .mt-50 { margin-top: 50px; }
                            .mt-60 { margin-top: 60px; }
                            .mt-100 { margin-top: 100px; }

                            ul {
                                margin: 5px 0 5px 20px;
                                padding-left: 10px;
                            }

                            li {
                                margin-bottom: 5px;
                            }
                            
                            /* HEADER TỔNG */
                            .header {
                                display: grid;
                                grid-template-columns: 0.8fr 2fr 0.8fr;
                                align-items: start;
                                margin-bottom: 16px;
                            }

                            /* CỘT TRÁI */
                            .header-left {
                                font-size: 11pt;      /* nhỏ hơn body */
                                line-height: 1.3;
                                text-align: left;
                            }

                            /* CỘT GIỮA – QUỐC HIỆU */
                            .header-center {
                                font-size: 12pt;      /* nhỏ hơn body (14pt) */
                                line-height: 1.35;
                                text-align: center;
                            }

                            /* Gạch dưới khẩu hiệu */
                            .header-center .national-sub {
                                display: inline-block;
                                padding-bottom: 2px;
                                border-bottom: 1px solid #000;
                            }

                            /* RIGHT */
                            .header-right {
                                /* để trống để cân bố cục */
                            }
                        }

                    `}
                </style>
            </div >
        );
    }
}

export default PrintCommitmentBracketRemoval;
